import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, Smartphone, Download } from "lucide-react";
import { APK_URL } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-foreground text-background overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="mb-5">
              <span className="inline-flex items-center justify-center rounded-2xl bg-background px-3 py-2">
                <img src="/logo.png" alt="NearbyDeals" className="h-10 w-auto" />
              </span>
            </div>
            <p className="text-background/70 max-w-xs leading-relaxed">
              The hyperlocal marketplace that keeps neighbourhoods thriving — discover offers,
              collect coupons and support the shops next door.
            </p>
            <div className="flex gap-3 mt-6">
              {[Instagram, Twitter, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="grid place-items-center w-10 h-10 rounded-full border border-background/20 hover:bg-primary hover:border-primary transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <a
              href={APK_URL}
              download="nearbydeals.apk"
              data-testid="footer-download-app"
              className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-primary text-primary-foreground font-semibold px-5 py-3 hover:bg-primary/90 transition-colors"
            >
              <Smartphone className="w-4 h-4" /> Download Android app
              <Download className="w-4 h-4" />
            </a>
          </div>

          <FooterCol
            title="Explore"
            items={[
              ["Browse shops", "/browse"],
              ["Categories", "/browse"],
              ["Get started", "/auth?mode=register"],
            ]}
          />
          <FooterCol
            title="Company"
            items={[
              ["About", "/about"],
              ["Contact", "/contact"],
            ]}
          />
          <FooterCol
            title="Legal"
            items={[
              ["Terms", "/terms"],
              ["Privacy", "/privacy"],
            ]}
          />
        </div>

        <div className="mt-16 pt-8 border-t border-background/15 flex flex-col sm:flex-row justify-between gap-4 text-sm text-background/60">
          <span>© {new Date().getFullYear()} NearbyDeals. Shop the neighbourhood.</span>
          <span>Made with care for local shops.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <h4 className="font-display font-bold text-sm uppercase tracking-widest text-background/50 mb-5">
        {title}
      </h4>
      <ul className="space-y-3">
        {items.map(([label, to]) => (
          <li key={label}>
            <Link
              to={to}
              className="text-background/80 hover:text-primary transition-colors font-medium"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
